var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.to)?_c('router-link',{class:_vm.theClass,attrs:{"to":_vm.to,"role":"button"},on:{"click":_vm.click}},[_c('span',{staticClass:"button-inner"},[_vm._t("default")],2)]):_c('button',{class:_vm.theClass,attrs:{"type":_vm.type ? _vm.type : 'button',"role":"button"},on:{"click":_vm.click}},[_c('span',{staticClass:"button-inner"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bf1c284","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/parts/components/button.vue
// module id = null
// module chunks = 